import { render, staticRenderFns } from "./ModalSample.vue?vue&type=template&id=5c0366b1&scoped=true&"
import script from "./ModalSample.vue?vue&type=script&lang=ts&"
export * from "./ModalSample.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSample.vue?vue&type=style&index=0&id=5c0366b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0366b1",
  null
  
)

export default component.exports